import { eventType } from './analyticsWebTypes';
import { buildAliases } from './buildAliases';
import { buildAttributesWithName } from './buildAttributesWithName';
import { buildCollaborationContextFields } from './buildCollaborationContextFields';
import { buildContainersWithName } from './buildContainersWithName';
import { buildEventOverrides } from './buildEventOverrides';
import { buildGroups } from './buildGroups';
import { buildOrgFields } from './buildOrgFields';
import { buildProductFields } from './buildProductFields';
import { buildTenantFields } from './buildTenantFields';
import { buildUserFields } from './buildUserFields';
import { buildWorkspaceFields } from './buildWorkspaceFields';
import {
	type BuiltScreenEvent,
	type CollaborationContextInfo,
	type InteractionSession,
	type InternalProductInfoType,
	type SendScreenEventInput,
} from './types';

function buildAttributes(attributes: any) {
	return buildAttributesWithName('attributes', attributes);
}

function buildNonPrivacySafeAttributes(nonPrivacySafeAttributes: any) {
	return buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export function buildScreenEvent(
	productInfo: InternalProductInfoType,
	tenantInfo: any,
	userInfo: any,
	attributes: any,
	nonPrivacySafeAttributes: any,
	tags: any,
	tabId: any,
	sessionId: any,
	taskSessions: any,
	interactionSession: InteractionSession,
	orgInfo: any,
	pageLoadId: string,
	workspaceInfo: any,
	collaborationContextInfo: CollaborationContextInfo,
	event: SendScreenEventInput,
	containers?: any,
	aliases?: any,
	groups?: any,
): BuiltScreenEvent {
	const productFields = buildProductFields(productInfo);
	const tenantFields = buildTenantFields(tenantInfo);
	const userFields = buildUserFields(userInfo);
	const orgFields = buildOrgFields(orgInfo);
	const workspaceFields = buildWorkspaceFields(workspaceInfo);
	const collaborationContextFields = buildCollaborationContextFields(collaborationContextInfo);
	const overrides = {
		title: '',
		path: '',
		url: '',
		referrer: '',
		search: '',

		eventType: eventType.SCREEN,
	};

	return {
		...productFields,
		...tenantFields,
		...userFields,
		...orgFields,
		...overrides,
		...buildAttributes(attributes),
		...buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
		...buildContainersWithName(containers),
		...buildEventOverrides(event),
		tags,
		tabId,
		sessionId,
		taskSessions,
		interactionSession,
		pageLoadId,
		...workspaceFields,
		...collaborationContextFields,
		...buildAliases(aliases),
		...buildGroups(groups),
	};
}
